import type { CourseModule } from "@/core/types";
import { lektionAlternativtexte } from "./lektion-01-alternativtexte";
import { lektionLesereihenfolge } from "./lektion-02-lesereihenfolge";
import { lektionKontrast } from "./lektion-03-kontrast";

export const modulBarrierefreiheit: CourseModule = {
  id: "barrierefreiheit",
  title: "Barrierefreiheit",
  summary:
    "Alternativtexte, die etwas beschreiben, eine Lesereihenfolge, die mit dem Titel " +
    "beginnt, und ein Kontrast, der auch auf einem alten Beamer trägt.",
  level: "Grundlagen",
  lessons: [lektionAlternativtexte, lektionLesereihenfolge, lektionKontrast],
};
